<script>
  export let logoSize = 37;
  export let text = "";
  import Logo from "./Logo.svelte";
</script>

<div class="header" style="--logoSize: {logoSize}px;">
    <Logo width={logoSize} />
    <div class="text">{text}</div>
</div>

<style>
    .header {
        display: flex;
        flex-direction: row;
    }
    .text {
        font-weight: 300;
        text-transform: uppercase;
        white-space: nowrap;
        line-height: var(--logoSize);
        margin-left: 10px;
    }
</style>
